export const environment = {
  production: true,
  apiUrl: 'https://api.ancelade.cloud/api/v1',
  panelUrl: 'https://my.ancelade.cloud',
  baseUrl: 'https://ancelade.cloud',

  // Identifiants publics stables du catalogue (indépendants des IDs DB)
  categorySlugs: {
    // Catégorie racine
    VPS: 'vps',

    // Processeurs (niveau 2)
    RYZEN: 'vps-ryzen',
    INTEL: 'vps-intel',

    // Types de virtualisation par processeur (niveau 3)
    RYZEN_LXC: 'vps-ryzen-lxc',
    RYZEN_KVM_LINUX: 'vps-ryzen-kvm-linux',
    RYZEN_KVM_WINDOWS: 'vps-ryzen-kvm-windows',

    INTEL_LXC: 'vps-intel-lxc',
    INTEL_KVM_LINUX: 'vps-intel-kvm-linux',
    INTEL_KVM_WINDOWS: 'vps-intel-kvm-windows',

    // Hébergement Web
    PLESK: 'hebergement-web-plesk',

    // Produits à tarification « custom » (barème porté par product.criteria)
    DATACENTER: 'datacenter',
    TUNNEL_IP: 'tunnel-ip',
  },
};
